import { FC } from "react";
import styled from "styled-components";

const Wrapper = styled("div")({
  width: "100%",
  height: "600px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const Button = styled("a")({
  backgroundColor: "#2D8CFF",
  borderColor: "#2D8CFF",
  padding: "6px 20px",
  textAlign: "center",
  margin: "10px 0",
  transition: ".3s ease",
  display: "table",
  textDecoration: "none",
  marginTop: "32px",
  color: "#ffffff",
  borderRadius: "3px",
  border: "2px solid #2D8CFF",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgb(45, 165, 255)",
    color: "#ffffff",
  },
});

interface IPlayer {
  contentUrl: string;
}

const NotSupported: FC<IPlayer> = ({ contentUrl }) => {
  return (
    <Wrapper>
      <Button href={contentUrl}>Click here to access content</Button>
    </Wrapper>
  );
};

export default NotSupported;
